module.exports = "<div class=q-marg-all-xl> <div class=\"q-pad-vert-md q-pad-horz-xl\"> Changing from a US destination to a non-US destination will cause the products added on the Products tab to be deleted. Please cancel if you not wish to lose these products. If you wish to continue with a non-US destination, please add new products in the Product tab. </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/modalOrderChangeToInternational.html
// module id = 1363
// module chunks = 1